// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalError-module__customMessageBox--lxaQq .ant-message-notice-content{color:#ff4d4f}`, "",{"version":3,"sources":["webpack://./src/root/App/GlobalError.module.scss"],"names":[],"mappings":"AAEQ,yEACI,aAAA","sourcesContent":[".customMessageBox {\r\n    :global {\r\n        .ant-message-notice-content {\r\n            color: #ff4d4f;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customMessageBox": `GlobalError-module__customMessageBox--lxaQq`
};
export default ___CSS_LOADER_EXPORT___;
